var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcreteExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9796 0.518555L20.1439 4.68292L18.6197 10.3723L16.5637 10.9232L14.6507 7.60976C13.6183 5.82152 11.0372 5.82153 10.0047 7.60976L9.50643 8.47282L8.76588 7.73226L10.2902 2.04283L15.9796 0.518555ZM8.56295 10.107L7.59652 9.14054L1.90709 10.6648L0.382812 16.3542L4.54717 20.5186L5.8613 20.1665C4.64573 19.467 4.09121 17.8523 4.8748 16.4951L8.56295 10.107ZM7.21608 7.6268L3.48162 8.62744L0.747356 5.89336L1.74826 2.15844L5.48271 1.15779L8.21698 3.89188L7.21608 7.6268Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8451 17.6126L12.7152 8.7273C12.5431 8.42927 12.113 8.42926 11.9409 8.7273L6.81097 17.6126C6.63889 17.9106 6.85398 18.2832 7.19813 18.2832H17.458C17.8021 18.2832 18.0172 17.9106 17.8451 17.6126ZM13.8767 8.05671C13.1884 6.86456 11.4677 6.86456 10.7794 8.05672L5.64947 16.942C4.96118 18.1342 5.82155 19.6244 7.19813 19.6244H17.458C18.8346 19.6244 19.6949 18.1342 19.0066 16.942L13.8767 8.05671Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7021 16.0815H12.9539V17.3333H11.7021V16.0815ZM11.7021 11.0745H12.9539V14.8298H11.7021V11.0745Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcreteExpired);
export default __webpack_public_path__ + "static/media/concrete-expired.10865dfd98f6c8bf2ccfece627581574.svg";
export { ForwardRef as ReactComponent };